import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { colors } from "@zapalacorp/tokens";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

import { Button } from "../../../../components/Form";

export const PageWrapper = styled("div")(() => ({
  display: "flex",
  height: "100%",
  width: "100%",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#FCFCFD",
}));

export const LoginForm = styled("form")(() => ({
  display: "flex",
  maxWidth: "442px",
  width: "100%",
  padding: "40px",
  flexDirection: "column",
  alignItems: "center",
  gap: "40px",
  borderRadius: "4px",
  borderTop: `4px solid ${colors.brandBlue500}`,
  background: "#FFF",
  boxShadow: "0px 1px 3px 0px rgba(71, 84, 103, 0.30), 0px 4px 8px 3px rgba(71, 84, 103, 0.15)",
  "@media screen and (max-width: 442px)": {
    height: "100%",
    justifyContent: "center",
  },
}));

export const LogoImage = styled("img")(() => ({
  maxHeight: 80,
  maxWidth: 352,
  "@media screen and (max-width: 442px)": {
    maxWidth: 280,
  },
}));

export const ContainerFooter = styled("div")(() => ({
  position: "absolute",
  bottom: 0,
  width: "100%",
  background: "#FFF",
  boxShadow: "0px -4px 8px 0px rgba(228, 231, 236, 0.30)",
}));

export const LoginInfo = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "12px",
  width: "100%",
}));

export const LoginTitle = styled("span")(() => ({
  color: "#475467",
  font: "500 36px Manrope",
  lineHeight: "44px",
}));

export const LoginSubtitle = styled("span")(() => ({
  color: "#475467",
  font: "400 16px Manrope",
  lineHeight: "24px",
  letterSpacing: "0.5px",
}));

export const LoginFormWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "24px",
  width: "100%",
}));

export const ShowPasswordIcon = styled(AiOutlineEye)(() => ({
  cursor: "pointer",
}));

export const HidePasswordIcon = styled(AiOutlineEyeInvisible)(() => ({
  cursor: "pointer",
}));

export const ForgotPasswordLink = styled("span")(() => ({
  font: "600 14px Manrope",
  color: colors.brandBlue500,
  cursor: "pointer",
}));

export const ForgotPasswordText = styled("span")(() => ({
  color: "#475467",
  font: "400 14px Manrope",
}));

export const ForgotPasswordContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  gap: "4px",
  width: "100%",

  "@media screen and (max-width: 442px)": {
    flexDirection: "column",
  },
}));

export const LoginButton = styled(Button)(() => ({
  backgroundColor: `${colors.brandBlue500} !important`,
  color: "#FFFFFF !important",
}));

const styles = makeStyles(() => ({
  label: {
    color: colors.brandBlue500,
  },
}));

export default styles;
